<template>
	<div>
		<v-card>
			<v-card-title><h3 class="mb-4">Custom Colors</h3></v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-row>
					<v-col cols="6">
						<v-expansion-panels v-model="customColorPanels1">
							<!-- Auditorium page -->
							<v-expansion-panel>
								<v-expansion-panel-header>
									<v-row no-gutters>
										<v-col cols="4">
											<h4>Auditorium Page</h4>
										</v-col>
									</v-row>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-row>
										<v-col cols="12">
											<v-text-field
												@
												v-model="auditoriumColor.backgroundColor"
												label="Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="auditoriumBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="auditoriumColor.backgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="auditoriumColor.additionalBackgroundColor"
												label="Additional Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="auditoriumAdditionalBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="auditoriumColor.additionalBackgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="auditoriumColor.highlightBackgroundColor"
												label="Highlight Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="auditoriumHighlightBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="auditoriumColor.highlightBackgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="auditoriumColor.dateBackgroundColor"
												label="Date Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="auditoriumDateBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="auditoriumColor.dateBackgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="auditoriumColor.fontColor"
												label="Font Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="auditoriumFontColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="auditoriumColor.fontColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="auditoriumColor.buttonBackgroundColor"
												label="Button Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="auditoriumButtonBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="auditoriumColor.buttonBackgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="auditoriumColor.buttonFontColor"
												label="Button Font Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="auditoriumButtonFontColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="auditoriumColor.buttonFontColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="auditoriumColor.searchBarColor"
												label="Search Bar Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="auditoriumSearchBarColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="auditoriumColor.searchBarColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="auditoriumColor.searchBarFontColor"
												label="Search Bar Font Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="auditoriumSearchBarFontColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="auditoriumColor.searchBarFontColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
									</v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>

							<!-- Presentation Page -->
							<v-expansion-panel>
								<v-expansion-panel-header>
									<v-row no-gutters>
										<v-col cols="4">
											<h4>Presentation Page</h4>
										</v-col>
									</v-row>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-row>
										<v-col cols="12">
											<v-text-field
												@
												v-model="presentationColor.backgroundColor"
												label="Top Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="presentationBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="presentationColor.backgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="presentationColor.bottomBackgroundColor"
												label="Bottom Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="presentationBottomBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="presentationColor.bottomBackgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="presentationColor.buttonBackgroundColor"
												label="Go to Chat Button Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="presentationButtonBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="presentationColor.buttonBackgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="presentationColor.buttonFontColor"
												label="Go to Chat Button Font Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="presentationButtonFontColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="presentationColor.buttonFontColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="presentationColor.buttonBackgroundColor2"
												label="Button Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="presentationButtonBackgroundColor2Picker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="presentationColor.buttonBackgroundColor2" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="presentationColor.buttonFontColor2"
												label="Button Font Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="presentationButtonFontColor2Picker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="presentationColor.buttonFontColor2" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
									</v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>

							<!-- Chat Networking Lounge Page -->
							<v-expansion-panel>
								<v-expansion-panel-header>
									<v-row no-gutters>
										<v-col cols="4">
											<h4>Chat Networking Lounge Page</h4>
										</v-col>
									</v-row>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-row>
										<v-col cols="12">
											<v-text-field
												@
												v-model="roomChatColor.backgroundColor"
												label="Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="roomChatBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="roomChatColor.backgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="roomChatColor.bubbleBackgroundColor"
												label="Chat Response Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="roomChatBubbleBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="roomChatColor.bubbleBackgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="roomChatColor.bubbleFontColor"
												label="Chat Response Font Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="roomChatBubbleFontColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="roomChatColor.bubbleFontColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
									</v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-col>
					<v-col cols="6">
						<v-expansion-panels v-model="customColorPanels2">
							<!-- Booth Page -->
							<v-expansion-panel>
								<v-expansion-panel-header>
									<v-row no-gutters>
										<v-col cols="4">
											<h4>Booth Page</h4>
										</v-col>
									</v-row>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-row>
										<v-col cols="12">
											<v-text-field
												@
												v-model="boothColor.backgroundColor"
												label="Top Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="boothBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="boothColor.backgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="boothColor.bottomBackgroundColor"
												label="Bottom Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="boothBottomBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="boothColor.bottomBackgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="boothColor.tabHoverColor"
												label="Tab Hover Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="boothTabHoverColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="boothColor.tabHoverColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="boothColor.buttonBackgroundColor"
												label="Go to Chat Button Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="boothButtonBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="boothColor.buttonBackgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="boothColor.buttonFontColor"
												label="Go to Chat Button Font Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="boothButtonFontColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="boothColor.buttonFontColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="boothColor.buttonBackgroundColor2"
												label="Button Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="boothButtonBackgroundColor2Picker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="boothColor.buttonBackgroundColor2" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												@
												v-model="boothColor.buttonFontColor2"
												label="Button Font Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="boothButtonFontColor2Picker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="boothColor.buttonFontColor2" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
									</v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>

							<!-- Leaderboard Page -->
							<v-expansion-panel>
								<v-expansion-panel-header>
									<v-row no-gutters>
										<v-col cols="4">
											<h4>Leaderboard Page</h4>
										</v-col>
									</v-row>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-row>
										<v-col cols="12">
											<v-text-field
												@
												v-model="leaderboardColor.backgroundColor"
												label="Top Three Background Color"
												filled
												hide-details
												class="ma-0 pa-0"
											>
												<template v-slot:append>
													<v-menu
														v-model="leaderboardBackgroundColorPicker"
														top
														nudge-bottom="40"
														nudge-left="16"
														:close-on-content-click="false"
													>
														<template v-slot:activator="{ on }">
															<v-icon v-on="on">mdi-palette</v-icon>
														</template>
														<v-card>
															<v-card-text class="pa-0">
																<v-color-picker v-model="leaderboardColor.backgroundColor" flat />
															</v-card-text>
														</v-card>
													</v-menu>
												</template>
											</v-text-field>
										</v-col>
									</v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>

						</v-expansion-panels>
					</v-col></v-row
				>
				<v-row>
					<v-col cols="6">
						<div class="d-flex">
							<v-btn color="primary" style="margin-right: 10px" @click="setDefaultColor"> reset</v-btn>
						</div>
					</v-col>
					<v-col cols="6">
						<div class="d-flex justify-end">
							<v-btn color="primary" style="margin-right: 10px" @click="dialogCustomColor = false"> cancel </v-btn>
							<v-btn color="primary" @click="saveCustomColor()">Save</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: ["experienceId"],
	data() {
		return {
			auditoriumColor: {
				backgroundColor: "#416D74FF",
				additionalBackgroundColor: "#3B5A5FFF",
				highlightBackgroundColor: "#1E1E1EFF",
				dateBackgroundColor: "#1E1E1EFF",
				fontColor: "#FFFFFFFF",
				buttonBackgroundColor: "#EB7226FF",
				buttonFontColor: "#FFFFFFFF",
				searchBarColor: "#000000DE",
				searchBarFontColor: "#FFFFFFFF"
			},
			auditoriumBackgroundColorPicker: false,
			auditoriumAdditionalBackgroundColorPicker: false,
			auditoriumHighlightBackgroundColorPicker: false,
			auditoriumDateBackgroundColorPicker: false,
			auditoriumFontColorPicker: false,
			auditoriumButtonBackgroundColorPicker: false,
			auditoriumButtonFontColorPicker: false,
			auditoriumSearchBarColorPicker: false,
			auditoriumSearchBarFontColorPicker: false,
			presentationColor: {
				backgroundColor: "#1E1E1EFF",
				bottomBackgroundColor: "#FFFFFFFF",
				fontColor: "#FFFFFFFF",
				buttonBackgroundColor: "#5f949cFF",
				buttonFontColor: "#FFFFFFFF",
				buttonBackgroundColor2: "#EB7226FF",
				buttonFontColor2: "#FFFFFFFF"
			},
			presentationBackgroundColorPicker: false,
			presentationBottomBackgroundColorPicker: false,
			presentationFontColorPicker: false,
			presentationButtonBackgroundColorPicker: false,
			presentationButtonFontColorPicker: false,
			presentationButtonBackgroundColor2Picker: false,
			presentationButtonFontColor2Picker: false,
			boothColor: {
				backgroundColor: "#416D74FF",
				bottomBackgroundColor: "#FFFFFFFF",
				fontColor: "#FFFFFFFF",
				buttonBackgroundColor: "#3B5A5FFF",
				buttonFontColor: "#FFFFFFFF",
				tabHoverColor: "#416d74FF",
				buttonBackgroundColor2: "#FF9800FF",
				buttonFontColor2: "#FFFFFFFF"
			},
			boothBackgroundColorPicker: false,
			boothBottomBackgroundColorPicker: false,
			boothFontColorPicker: false,
			boothButtonBackgroundColorPicker: false,
			boothButtonFontColorPicker: false,
			boothTabHoverColorPicker: false,
			boothButtonBackgroundColor2Picker: false,
			boothButtonFontColor2Picker: false,
			roomChatColor: {
				backgroundColor: "#4e7c83FF",
				fontColor: "#FFFFFFFF",
				bubbleFontColor: "#000000DE",
				bubbleBackgroundColor: "#5F949C"
			},
			roomChatBackgroundColorPicker: false,
			roomChatFontColorPicker: false,
			roomChatBubbleFontColorPicker: false,
			roomChatBubbleBackgroundColorPicker: false,
			leaderboardColor: {
				backgroundColor: "#416D74FF"
			},
			leaderboardBackgroundColorPicker: false,
			networkingColor: {
				backgroundColor: "#416D74FF",
				highlightBackgroundColor: "#1E1E1EFF",
				additionalBackgroundColor: "214D54FF",
				fontColor: "#FFFFFFFF",
				buttonBackgroundColor: "#EB7226FF",
				buttonBackgroundColor2: "#00838FFF",
				buttonBackgroundColor3: "#FFFFFFFF",
				searchBarColor: "#000000DE"
			},
			networkingBackgroundColorPicker: false,
			networkingAdditionalBackgroundColorPicker: false,
			networkingHighlightBackgroundColorPicker: false,
			networkingFontColorPicker: false,
			networkingButtonBackgroundColorPicker: false,
			networkingButtonBackgroundColor2Picker: false,
			networkingButtonBackgroundColor3Picker: false,
			networkingSearchBarColorPicker: false,
			conversationColor: {
				backgroundColor: "#4e7c83FF",
				fontColor: "#FFFFFFFF",
				bubbleFontColor: "#000000DE",
				bubbleBackgroundColor: "#5F949C"
			},
			conversationtBackgroundColorPicker: false,
			conversationFontColorPicker: false,
			conversationBubbleFontColorPicker: false,
			conversationBubbleBackgroundColorPicker: false,
			customColorPanels1: 0,
			customColorPanels2: 0
		};
	},
	mounted() {
		this.list();
	},
	methods: {
		list() {
			axios
				.get("/system/experienceColors/find?experienceId=" + this.experienceId)
				.then((response) => {
					if (response.data) {
						let experienceColorsList = response.data;
						for (let colors of experienceColorsList) {
							if (colors.page == "Auditorium") {
								this.auditoriumColor = colors;
							} else if (colors.page == "Presentation") {
								this.presentationColor = colors;
							} else if (colors.page == "Booth") {
								this.boothColor = colors;
							} else if (colors.page == "Room_Chat") {
								this.roomChatColor = colors;
							} else if (colors.page == "Leaderboard") {
								this.leaderboardColor = colors;
							} else if (colors.page == "Networking_Lounge") {
								this.networkingColor = colors;
							} else if (colors.page == "Conversation_Community_Networking") {
								this.conversationColor = colors;
							}
						}
					}
				})
				.catch(() => {});
		},
		saveCustomColor() {
			let url = this.auditoriumColor.id ? "/system/experienceColors/edit" : "/system/experienceColors/add";
			axios
				.post(url, {
					auditoriumColor: this.auditoriumColor,
					presentationColor: this.presentationColor,
					boothColor: this.boothColor,
					roomChatColor: this.roomChatColor,
					leaderboardColor: this.leaderboardColor,
					networkingColor: this.networkingColor,
					conversationColor: this.conversationColor,
					experienceId: this.experienceId
				})
				.then(() => {
					this.list();
				})
				.catch(() => {});
		},
		setDefaultColor() {
			this.auditoriumColor.backgroundColor = "#416D74FF";
			this.auditoriumColor.additionalBackgroundColor = "#3B5A5FFF";
			this.auditoriumColor.highlightBackgroundColor = "#1E1E1EFF";
			this.auditoriumColor.dateBackgroundColor = "#1E1E1EFF";
			this.auditoriumColor.fontColor = "#FFFFFFFF";
			this.auditoriumColor.buttonBackgroundColor = "#EB7226FF";
			this.auditoriumColor.buttonFontColor = "#FFFFFFFF";
			this.auditoriumColor.searchBarColor = "#000000DE";
			this.auditoriumColor.searchBarFontColor = "#FFFFFFFF";

			this.presentationColor.backgroundColor = "#FFFFFFFF";
			this.presentationColor.fontColor = "#000000";
			this.presentationColor.buttonBackgroundColor = "#1fabed";
			this.presentationColor.buttonFontColor = "#FFFFFFFF";
			this.presentationColor.buttonBackgroundColor2 = "#EB7226FF";
			this.presentationColor.buttonFontColor2 = "#FFFFFFFF";
			this.presentationColor.bottomBackgroundColor = "#FFFFFFFF";

			this.boothColor.backgroundColor = "#416D74FF";
			this.boothColor.fontColor = "#FFFFFFFF";
			this.boothColor.buttonBackgroundColor = "#3B5A5FFF";
			this.boothColor.buttonFontColor = "#FFFFFFFF";
			this.boothColor.tabHoverColor = "#416d74FF";
			this.boothColor.buttonBackgroundColor2 = "#FF9800FF";
			this.boothColor.buttonFontColor2 = "#FFFFFFFF";
			this.boothColor.bottomBackgroundColor = "#FFFFFFFF";

			this.roomChatColor.backgroundColor = "#4e7c83FF";
			this.roomChatColor.fontColor = "#FFFFFFFF";
			this.roomChatColor.bubbleFontColor = "#000000DE";
			this.roomChatColor.bubbleBackgroundColor = "#5F949C";

			this.networkingColor.backgroundColor = "#416D74FF";
			this.networkingColor.additionalBackgroundColor = "#214D54FF";
			this.networkingColor.highlightBackgroundColor = "#1E1E1EFF";
			this.networkingColor.fontColor = "#FFFFFFFF";
			this.networkingColor.buttonBackgroundColor = "#EB7226FF";
			this.networkingColor.buttonBackgroundColor2 = "#00838FFF";
			this.networkingColor.buttonBackgroundColor3 = "#FFFFFFFF";
			this.networkingColor.searchBarColor = "#000000DE";

			this.conversationColor.backgroundColor = "#4e7c83FF";
			this.conversationColor.fontColor = "#FFFFFFFF";
			this.conversationColor.bubbleFontColor = "#000000DE";
			this.conversationColor.bubbleBackgroundColor = "#5F949C";

			this.leaderboardColor.backgroundColor = "#416D74FF";
		}
	}
};
</script>
